<template>
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <h2>Reset your password</h2>
        <label>New Password</label>
        <input type="password" class="form-control mb-3" v-model="password">
        <div :class="{'text-success': finished,'text-danger': error}">
          {{ message }}
        </div>
        <button v-if="!finished" @click.prevent="submitPassword" class="btn btn-success">Save</button>
        <router-link v-if="finished" :to="{name: 'login'}" class="btn btn-success">Log In</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/services/userService'

export default {
  name: 'ResetPasswordConfirm',
  data: function(){
    return {
      password: '',
      message: '',
      error: false,
      finished: false
    }
  },
  methods: {
    submitPassword () {
      this.error = false
      this.finished = false
      this.message = ''
      userService.confirmResetPassword({password: this.password, token: this.$route.params.token})
        .then(() => {
          this.finished = true
          this.message = 'Your password has been changed. You can log in with your new password.'
          this.password = ''
        }).catch(err => {
          this.error = true
          this.password = ''
          if (err.response.status == 404) {
            this.message = 'Token not found'
          } else {
            this.message = err.response.data.password[0]
          }
        })
    }
  }
}
</script>
